import { Language } from '@shopee-user/global';

export const DEFAULT_ERROR_MESSAGE: Record<Language, string> = Object.freeze({
  [Language.en]: 'Sorry, an error has occurred.',
  [Language.id]: 'Maaf, sebuah kesalahan telah terjadi.',
  [Language.ms]: 'Maaf, kesulitan telah berlaku.',
  [Language.th]: 'ขออภัย เกิดข้อผิดพลาดบางอย่าง',
  [Language.vi]: 'Uiiiii, có lỗi mất rồi.',
  [Language['zh_Hans']]: '抱歉，发生错误了。',
  [Language['zh_Hant']]: '抱歉, 發生錯誤。',
  [Language['pt_BR']]: 'Desculpe, houve um erro.',
  [Language.es_MX]: 'Lo sentimos, se ha producido un error.',
  [Language.es_CL]: 'Lo sentimos, se ha producido un error.',
  [Language.es_CO]: 'Lo sentimos, se ha producido un error.',
  [Language.fil]: 'Sorry, may naganap na error.',
});
